export enum InOutType {
  IN = 1,
  OUT = 2,
}